import classNames from "classnames";
import style from "./monday-task-column-picker.module.css";
import { ColumnPinIcon } from "../../components/monday-task-icons";
import Checkbox from "frontend/ui-components/design-system/checkbox/checkbox";
import { MondayItemColumn } from "elements/monday-task/controller";
import { Tooltip } from "frontend/ui-components/design-system/tooltip/tooltip";
import tracking from "frontend/tracking";

interface MondayTaskColumnPickerRowProps {
  column: MondayItemColumn;
  isHidden: boolean;
  isPinned: boolean;
  allowPin: boolean;
  onToggle: (columnId: string) => void;
  onPin: (columnId: string) => void;
}

export function MondayTaskColumnPickerRow({
  column,
  isHidden,
  isPinned,
  allowPin,
  onToggle,
  onPin,
}: MondayTaskColumnPickerRowProps) {
  const handleToggleVisibility = () => {
    tracking.trackAnalyticsEvent("monday_task_column_visibility_changed", {
      columnType: column.type,
      action: isHidden ? "showing" : "hiding",
    });
    onToggle(column.id);
  };

  const handleTogglePin = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (!isPinned && !allowPin) return;
    tracking.trackAnalyticsEvent("monday_task_column_pinned", {
      columnType: column.type,
      action: isPinned ? "unpinned" : "pinned",
    });
    onPin(column.id);
  };

  return (
    <div className={style.columnRow} onClick={handleToggleVisibility}>
      <div className={style.columnRowCheckbox}>
        <Checkbox theme="dark" checked={!isHidden} />
        <div className={style.columnLabel}>{column.title}</div>
      </div>
      {!isHidden && (
        <Tooltip text="You cannot pin any more columns" side="top" offset={8} disabled={allowPin || isPinned}>
          <button
            className={classNames(style.pinButton, {
              [style.pinned]: isPinned,
              [style.disabled]: !isPinned && !allowPin,
            })}
            onClick={handleTogglePin}
          >
            <ColumnPinIcon />
          </button>
        </Tooltip>
      )}
    </div>
  );
}
